var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiledownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons "
  }, /*#__PURE__*/React.createElement("path", {
    id: "download",
    d: "M8.5 10.6812C8.4 10.6812 8.30625 10.6656 8.21875 10.6344C8.13125 10.6031 8.05 10.55 7.975 10.475L5.275 7.775C5.125 7.625 5.05313 7.45 5.05938 7.25C5.06563 7.05 5.1375 6.875 5.275 6.725C5.425 6.575 5.60312 6.49688 5.80937 6.49063C6.01562 6.48438 6.19375 6.55625 6.34375 6.70625L7.75 8.1125V2.75C7.75 2.5375 7.82188 2.35938 7.96562 2.21562C8.10938 2.07187 8.2875 2 8.5 2C8.7125 2 8.89063 2.07187 9.03438 2.21562C9.17813 2.35938 9.25 2.5375 9.25 2.75V8.1125L10.6562 6.70625C10.8062 6.55625 10.9844 6.48438 11.1906 6.49063C11.3969 6.49688 11.575 6.575 11.725 6.725C11.8625 6.875 11.9344 7.05 11.9406 7.25C11.9469 7.45 11.875 7.625 11.725 7.775L9.025 10.475C8.95 10.55 8.86875 10.6031 8.78125 10.6344C8.69375 10.6656 8.6 10.6812 8.5 10.6812ZM4 14C3.5875 14 3.23438 13.8531 2.94063 13.5594C2.64688 13.2656 2.5 12.9125 2.5 12.5V11C2.5 10.7875 2.57187 10.6094 2.71562 10.4656C2.85938 10.3219 3.0375 10.25 3.25 10.25C3.4625 10.25 3.64062 10.3219 3.78437 10.4656C3.92813 10.6094 4 10.7875 4 11V12.5H13V11C13 10.7875 13.0719 10.6094 13.2156 10.4656C13.3594 10.3219 13.5375 10.25 13.75 10.25C13.9625 10.25 14.1406 10.3219 14.2844 10.4656C14.4281 10.6094 14.5 10.7875 14.5 11V12.5C14.5 12.9125 14.3531 13.2656 14.0594 13.5594C13.7656 13.8531 13.4125 14 13 14H4Z",
    fill: "#FBFBFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiledownload);
export default __webpack_public_path__ + "static/media/File download.e9d6957b8498257f9ef3ec598a680109.svg";
export { ForwardRef as ReactComponent };